import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { AchEnrollmentState } from '../state/ach-enrollment.state';

export const createAchEnrollmentState = createFeatureSelector<AchEnrollmentState>('achEnrollment');

export const achEnrollmentFeatureKey = 'achEnrollment';

export const getAchEnrollment = createSelector(
    createAchEnrollmentState,
    (state: AchEnrollmentState) => state.achEnrollment
);

@Injectable({
    providedIn: 'root',
})
export class AchEnrollmentSelectors {
    constructor(private store: Store<AchEnrollmentState>) {}
    achEnrollment$ = this.store.select(getAchEnrollment);
}
